import { render, staticRenderFns } from "./CreateMember.vue?vue&type=template&id=051b20a8&scoped=true"
import script from "./CreateMember.vue?vue&type=script&lang=js"
export * from "./CreateMember.vue?vue&type=script&lang=js"
import style0 from "./CreateMember.vue?vue&type=style&index=0&id=051b20a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051b20a8",
  null
  
)

export default component.exports